import React, { useState, ReactNode } from 'react';
import { VisibilityContext } from './context';

export const VisibilityProvider = ({ children }: { children: ReactNode }) => {
  const [visibilityData, setVisibilityData] = useState({
    showHeader: true,
    showProfileNav: true,
  });
  return (
    <VisibilityContext.Provider value={{ visibilityData, setVisibilityData }}>
      {children}
    </VisibilityContext.Provider>
  );
};
